<template>
  <div class="ui small modal" ref="modal">
    <div class="header">{{ $t("exchange check") }}</div>
    <div class="content">
      <div class="ui form">
        <div class="two disabled fields">
          <div class="field">
            <label for="">{{ $t("customer name") }}</label>
            <input type="text" v-model="d.setup.name" />
          </div>
          <div class="field">
            <label for="">{{ $t("customer email") }}</label>
            <input type="text" v-model="d.setup.email" />
          </div>
        </div>
        <div class="two disabled fields">
          <div class="field">
            <label for="">{{ $t("bill or ticket number") }}</label>
            <input type="text" v-model="d.setup.bill_number" />
          </div>
          <div class="field">
            <label for="">{{ $t("card or notebook serial number") }}</label>
            <input type="text" v-model="d.setup.card_or_notebook_serial" />
          </div>
        </div>
        <div class="two disabled fields">
          <div class="field">
            <label for="">{{ $t("brand") }}</label>
            <input type="text" v-model="d.setup.brand" />
          </div>
          <div class="field">
            <label for="">{{ $t("gpu") }}</label>
            <input type="text" v-model="d.setup.gpu_type" />
          </div>
        </div>
        <div class="field" v-bind:class="{ disabled: d.status_code != 'R' }">
          <label for="">{{ $t("comment") }}</label>
          <textarea name="comment" rows="2" v-model="comment"></textarea>
        </div>
      </div>
      <div class="ui basic segment">
        <img
          class="ui centered medium image"
          :src="api_host + '/' + d.setup.upload.relative_path"
        />
      </div>
      <!-- <pre>{{ d.setup }}</pre> -->
    </div>
    <div class="actions">
      <div
        class="ui left floated green icon labeled button"
        @click="approve"
        v-show="d.status_code == 'R'"
      >
        <i class="check icon"></i>{{ $t("approve") }}
      </div>
      <div
        class="ui left floated red icon labeled button"
        @click="retrn"
        v-show="d.status_code == 'R'"
      >
        <i class="dont icon"></i> {{ $t("deny") }}
      </div>
      <div class="ui left floated orange icon labeled button" @click="remove">
        <i class="trash icon"></i> {{ $t("remove") }}
      </div>
      <div class="ui cancel red button">
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import { api_host, local_api, error_toast, success_toast } from "@/utils";
import filters from "@/filters";

export default {
  name: "NworkforceExchangeModal",
  filters: filters,
  components: {},
  computed: {},
  props: {},
  data() {
    return {
      d: {
        setup: { upload: {} },
      },
      comment: "",
      api_host: api_host,
    };
  },
  methods: {
    show(data) {
      let vm = this;
      vm.d = data;
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHidden() {
            vm.$emit("done");
            vm.comment = "";
          },
        })
        .modal("show");
    },
    approve() {
      let vm = this;
      local_api(vm, "post", "/nworkforce_exchange/exchange/do-approve", {
        d: vm.d,
        c: vm.comment,
      })
        .then((/* r */) => {
          success_toast(vm.$t("request approved"));
          window.jQuery(vm.$refs.modal).modal("hide");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    retrn() {
      let vm = this;
      local_api(vm, "post", "/nworkforce_exchange/exchange/do-deny", {
        d: vm.d,
        c: vm.comment,
      })
        .then((/* r */) => {
          success_toast(vm.$t("request denied"));
          window.jQuery(vm.$refs.modal).modal("hide");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    remove() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove exchange?"),
        function() {
          local_api(vm, "post", "/nworkforce_exchange/exchange/do-remove", {
            i: vm.d.exchange_id,
          })
            .then(() => {
              success_toast(vm.$t("request deleted"));
              window.jQuery(vm.$refs.modal).modal("hide");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
